import { createSlice } from "@reduxjs/toolkit";

export const rolesSlice = createSlice({
  name: "roles",
  initialState: {
    roles: [],
    roleCategories: [],
    selectedRole: null,
    count: 0,
    next: null,
    previous: null,
  },
  reducers: {
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
    setRolesResult: (state, action) => {
      const { data, pagination } = action.payload;
      state.roles = data || [];
      state.count = pagination?.count || 0;
      state.next = pagination?.next || null;
      state.previous = pagination?.previous || null;
    },
    clearRoles: (state) => {
      state.roles = [];
      state.count = 0;
      state.next = null;
      state.previous = null;
    },
    setRoleCategories: (state, action) => {
      state.roleCategories = action.payload;
    },
    clearRoleCategories: (state) => {
      state.roleCategories = [];
    },
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    },
    clearSelectedRole: (state) => {
      state.selectedRole = null;
    },
  },
});

export const {
  setRoles,
  setRolesResult,
  clearRoles,
  setRoleCategories,
  clearRoleCategories,
  setSelectedRole,
  clearSelectedRole,
} = rolesSlice.actions;

export default rolesSlice.reducer;
